import {Environment} from './Environment';
import {Locale} from './Locale';
import {StorageUtility} from './Storage';
import {UI} from './UI';
import {URLManager} from './URLManager';

declare var $: any;
declare var window: any;

export class GDPR {
    static getInstance() {
        if (!GDPR.instance) {
            GDPR.instance = new GDPR();
        }
        return GDPR.instance;
    }
    private static instance: GDPR;

    private constructor() {
        // Defer jQuery-dependent initialization until jQuery is available
        this.initializeWhenReady();
    }

    private initializeWhenReady() {
        // Check if jQuery is available, if not, wait for it
        if (typeof $ === 'undefined') {
            // Wait for jQuery to be available
            setTimeout(() => this.initializeWhenReady(), 10);
            return;
        }

        // Now that jQuery is available, initialize
        this.registerEventListeners();

        UI.getInstance().domReady(() => {
            const pageType = $('.main').attr('page-type');
            if (Environment.getInstance().isMobile() || pageType === 'b2b') {
                $('body').addClass('no-cookie-consent-banner');
            }
        });

        $(() => {
            if (Environment.getInstance().isMobile() || $('.main').attr('page-type') === 'b2b') {
                $('body').addClass('no-cookie-consent-banner');
            }
        });
    }

    /////////////////////////////////////////////////////////////////////

    public hasConsent() {
        return localStorage.keeper_cookie_consent === 'true';
    }

    /////////////////////////////////////////////////////////////////////

    public setConsent(consent: any = null) {
        // Safety check to ensure jQuery is available
        if (typeof $ === 'undefined') {
            console.warn('jQuery library not available yet');
            return;
        }

        try {
            if (consent === null || consent === undefined) {
                $('body').removeClass('user-cookie-consent');
                $('body').removeClass('no-cookie-consent');
                $('body').removeClass('cookie-consent');
                return;
            }

            localStorage.keeper_cookie_consent = consent;

            if (consent === 'true' || consent === true) {
                $('body').addClass('user-cookie-consent');
                $('body').removeClass('no-cookie-consent');
                $('body').removeClass('cookie-consent');

                $(function (event) {
                    if (!URLManager.getInstance().getParams()['email']) {
                        StorageUtility.getInstance().loadScripts();
                    }

                    if (window.studentDiscountCallBack) {
                        window.studentDiscountCallBack();
                    }
                });

                StorageUtility.getInstance().refresh();
            }

            if (consent === 'false' || consent === false) {
                $('body').addClass('no-cookie-consent');
                $('body').removeClass('user-cookie-consent');
                $('body').removeClass('cookie-consent');
                StorageUtility.getInstance().clear();

                if (window.studentDiscountNoConsentCallBack) {
                    window.studentDiscountNoConsentCallBack();
                }

                // Update consent state
                if (window.gtag) {
                    window.gtag('consent', 'update', {
                        ad_storage: 'denied',
                        ad_user_data: 'denied',
                        ad_personalization: 'denied',
                        analytics_storage: 'denied',
                    });
                }

                window.uetq = window.uetq || [];
                window.uetq.push('consent', 'update', {
                    ad_storage: 'denied',
                });

                return;
            }
        } catch (error) {
            console.error(error);
        }
    }

    /////////////////////////////////////////////////////////////////////

    public registerEventListeners() {
        // Safety check to ensure jQuery is available
        if (typeof $ === 'undefined') {
            console.warn('jQuery library not available yet');
            return;
        }

        const self = this;

        $(window).on('resize load', () => {
            const $banner = $('.cookie-consent-banner');
            const $chat = $('.chat-with-support');

            if ($('.cookie-consent-banner').css('display') === 'none') {
                $chat.css('bottom', 0);
                $chat.css('inset-inline-end', 0);
            } else {
                $chat.css('bottom', $banner.height() + 100);
                $chat.css('inset-inline-end', '40px');
            }
        });

        $(document).on('click change', "[type='checkbox'][name='privacy']", e => {
            if (e && e.target && e.target.checked) {
                self.setConsent('true');
            }
        });

        $(document).on('click', '.cookie_accept', event => {
            event.preventDefault();
            self.setConsent('true');
        });

        $(document).on('click', '.cookie_decline', event => {
            event.preventDefault();
            self.setConsent('false');
            $(window).trigger('resize');
        });

        $(document).on(
            'click',
            '[data-close="cookie-consent-popup"], #cookie-consent-popup .overlay',
            function (event) {
                $('body').removeClass('no-scroll');
                $('.header, .main, .footer').removeClass('blurForModal');
                $('#cookie-consent-popup').removeClass('moduleVisible');
                $('.overlay').removeClass('overlayVisible');
            }
        );

        $(document).on('click', '.cookie_withdraw', function (event) {
            event.preventDefault();
            self.setConsent('false');
            $('body').removeClass('no-scroll');
            $('.header, .main, .footer').removeClass('blurForModal');
            $('#cookie-consent-popup').removeClass('moduleVisible');
            $('.overlay').removeClass('overlayVisible');

            if (window.location.href.indexOf('cookie-consent-popup') != -1) {
                window.location.href = URLManager.getInstance().removeParam('cookie-consent-popup');
                return;
            }

            window.location.reload();
        });

        $(document).on('click', '.cookie_cancel', function (event) {
            event.preventDefault();
            $('body').removeClass('no-scroll');
            $('.header, .main, .footer').removeClass('blurForModal');
            $('#cookie-consent-popup').removeClass('moduleVisible');
            $('.overlay').removeClass('overlayVisible');

            if ($(event.target).hasClass('cookie_cancel_consent')) {
                self.setConsent('false');
            }
        });

        $(document).on('click', '.chat-with-support', function () {
            if (!window.matchMedia('(min-width: 768px)').matches) {
                // if mobile
                $('#cookie_onload_popup').trigger('click');
            } else if ($('.main').attr('page-type') === 'b2b') {
                $('#cookie_onload_popup').trigger('click');
            } else {
                $('body').removeClass('cookie-consent');
                $('body').removeClass('no-cookie-consent');
                $('body').removeClass('no-cookie-consent-banner');
                $('.chat-with-support').removeClass('bring-to-bottom');
                $(window).trigger('resize');
            }
        });

        if (URLManager.getInstance().getParams()['cookie-consent-popup']) {
            $(() => {
                $('body').addClass('no-scroll');
                $('.header, .main, .footer').addClass('blurForModal');
                $('#cookie-consent-popup').addClass('moduleVisible');
                $('#cookie-consent-popup .overlay').addClass('overlayVisible');
            });
        }

        $(document).on('click', '#cookie_onload_popup', function () {
            $('body').addClass('no-scroll');
            $('.header, .main, .footer').addClass('blurForModal');
            $('#cookie-consent-popup').addClass('moduleVisible');
            $('#cookie-consent-popup .overlay').addClass('overlayVisible');
        });

        $(document).on('click', '.show_consent_popup', function () {
            $('body').addClass('no-scroll');
            $('.header, .main, .footer').addClass('blurForModal');
            $('#cookie-consent-popup').addClass('moduleVisible');
            $('#cookie-consent-popup .overlay').addClass('overlayVisible');
            $('[data-show-on-popup="false"]').show();
        });
    }

    /////////////////////////////////////////////////////////////////////

    public sendAnalytics() {
        if (window.isUserFromUS === true || localStorage.keeper_cookie_consent === 'true') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event: 'keeper_cookie_consent'});

            // Update consent signals
            if (window.gtag) {
                window.gtag('consent', 'update', {
                    ad_storage: 'granted',
                    ad_user_data: 'granted',
                    ad_personalization: 'granted',
                    analytics_storage: 'granted',
                });
            }

            window.uetq = window.uetq || [];
            window.uetq.push('consent', 'update', {
                ad_storage: 'granted',
            });
        }

        if (
            window.isUserFromUS === false &&
            (localStorage.keeper_cookie_consent === undefined ||
                localStorage.keeper_cookie_consent === 'false')
        ) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({event: 'no_keeper_cookie_consent'});

            // Update consent signals
            if (window.gtag) {
                window.gtag('consent', 'update', {
                    ad_storage: 'denied',
                    ad_user_data: 'denied',
                    ad_personalization: 'denied',
                    analytics_storage: 'denied',
                });
            }

            window.uetq = window.uetq || [];
            window.uetq.push('consent', 'update', {
                ad_storage: 'denied',
            });
        }

        if (Locale.getInstance().isOriginalKeeperRegion('EU') && window.hasGTMLoaded === true) {
            window.dataLayer.push({event: 'eu_country_flag'});
        } else if (window.hasGTMLoaded === true) {
            window.dataLayer.push({event: 'non_eu_country_flag'});
        }
    }
}

export default GDPR;
